<div class="tree-view">
  @for (node of nodes; track node.label) {
    @if (node.show !== false && showNode(node)) {
      <div class="tree-node" [class.selected]="isSelected(node)">
        @if (hasChildren(node)) {
          <button type="button" class="tree-node-content focus-ring" [attr.aria-expanded]="node.expanded" (click)="toggleNode(node)">
            <ng-container *ngTemplateOutlet="nodeBody; context: { $implicit: node }"></ng-container>

            <span class="tree-node-toggle has-children" [class.expanded]="node.expanded">
              <span class="toggle-icon">
                <span class="material-symbols-outlined">
                  {{ node.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                </span>
              </span>
            </span>
          </button>
        } @else if (node.path) {
          <a class="tree-node-content focus-ring" [routerLink]="node.path" (click)="selectNode(node)">
            <ng-container *ngTemplateOutlet="nodeBody; context: { $implicit: node }"></ng-container>
          </a>
        } @else {
          <div class="tree-node-content focus-ring" (click)="selectNode(node)">
            <ng-container *ngTemplateOutlet="nodeBody; context: { $implicit: node }"></ng-container>
          </div>
        }

        @if ((node.expanded || isClosing(node)) && hasChildren(node)) {
          <div class="tree-node-children" [class.closing]="isClosing(node)">
            <tree-view
              [nodes]="node.children"
              [selectedNodeId]="selectedNodeId"
              (selectedNodeChange)="onChildSelectedChange($event)">
            </tree-view>
          </div>
        }
      </div>
    }
  }
</div>

<ng-template #nodeBody let-node>
  @if (node.icon) {
    <span class="tree-node-icon material-symbols-outlined">
      {{ node.icon }}
    </span>
  }

  <span class="tree-node-label truncate">{{ node.label }}</span>
</ng-template>
